export const appendAudit = (grefs, node, button, target) => {
  if (
    grefs.auditTrail.current.findIndex((item) => item.nodeId === node) === -1
  ) {
    grefs.auditTrail.current.push({ nodeId: node, button: button, target });
  }
};
export const editAudit = (grefs, node, chosen, uploaded = "") => {
  const targets = grefs.edgeCollectionRef.current.filter((edge) => {
    return edge.source === node;
  });

  let uploadIndex = grefs.auditTrail.current.findIndex(
    (item) => item.nodeId === node
  );

  if (uploadIndex === -1) {
    grefs.auditTrail.current.push({ nodeId: node, target: targets[0].target });
    uploadIndex = grefs.auditTrail.current.length - 1;
  }
  const newNode = chosen
    ? {
        ...grefs.auditTrail.current[uploadIndex],
        filename: chosen.name,
        filetype: chosen.type,
        filesize: chosen.size,
        uploaded: null,
        file: chosen,
      }
    : uploaded
    ? { ...grefs.auditTrail.current[uploadIndex], uploaded: uploaded }
    : grefs.auditTrail.current[uploadIndex];
  grefs.auditTrail.current[uploadIndex] = newNode;
};
